import { render, staticRenderFns } from "./backup_codes.vue?vue&type=template&id=d9b7cc3a&"
import script from "./backup_codes.vue?vue&type=script&lang=js&"
export * from "./backup_codes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports